var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hlt-nav-container"},[_c('main-nav'),_c('div',{staticClass:"sub-nav-container"},[_c('div',{staticClass:"list-elements"},[_vm._t("listItems")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }